export const LOADING_LOGIN_TRANSLATIONS: Record<
  string,
  {
    subtitle: string;
    message: string;
    iframeSubtitle: string;
    iframeMessage: string;
    iframeLoginButton: string;
    iframePopupBlockedMessage: string;
    iframeRetryButton: string;
  }
> = {
  en: {
    subtitle: 'Secure Authentication',
    message: 'Authenticating with Microsoft...',
    iframeSubtitle: 'Sign in required',
    iframeMessage:
      'You are viewing this application inside an embedded frame. Click the button below to open a sign-in popup.',
    iframeLoginButton: 'Sign in with Microsoft',
    iframePopupBlockedMessage:
      'The sign-in popup was blocked by your browser. Please allow popups for this site and try again.',
    iframeRetryButton: 'Try again',
  },
  de: {
    subtitle: 'Sichere Authentifizierung',
    message: 'Authentifizierung mit Microsoft...',
    iframeSubtitle: 'Anmeldung erforderlich',
    iframeMessage:
      'Diese Anwendung wird in einem eingebetteten Fenster (iFrame) angezeigt. Klicken Sie auf die Schaltfläche unten, um ein Anmelde-Popup zu öffnen.',
    iframeLoginButton: 'Mit Microsoft anmelden',
    iframePopupBlockedMessage:
      'Das Anmelde-Popup wurde vom Browser blockiert. Bitte erlauben Sie Popups für diese Seite und versuchen Sie es erneut.',
    iframeRetryButton: 'Erneut versuchen',
  },
};
